import {Component, OnInit} from '@angular/core';
import {AppService} from '../../../../services/app.service';
import * as $ from 'jquery';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-exclusive-top-slider',
  templateUrl: './exclusive-top-slider.component.html',
  styleUrls: ['./exclusive-top-slider.component.css']
})
export class ExclusiveTopSliderComponent implements OnInit {

  selectedCity = '';
  public banners;

  constructor(
    public appService: AppService,
    private http: HttpClient,
  ) {
  }

  ngOnInit(): void {
    this.selectedCity = this.appService.getCurrentCity();
    this.getBanners();
  }

  playMasterVideo(e): void {
    if (this.selectedCity.toLowerCase() === 'mumbai') {
      $(e).parents('.video-poster').hide();
      $(e).parents('.video-poster').siblings('.video-stream').show();
      $(e).parents('.video-poster').siblings('.video-stream').children('video').get(0).play();
    } else {
      $(e).parents('.video-poster-pune').hide();
      $(e).parents('.video-poster-pune').siblings('.video-stream').show();
      $(e).parents('.video-poster-pune').siblings('.video-stream').children('video').get(0).play();
    }
  }

  getBanners(): void {
    const httpOptions = {
      headers: new HttpHeaders({'Content-Type': 'application/json'})
    };

    this.http.get<any>(environment.domain + '/api/' + this.appService.getCurrentCity().toLowerCase() + '/banners/experience/top', httpOptions).subscribe(
      data => {
        if (data.type === 'success') {
          this.banners = data.data;
        }
      },
      error => {
        console.error('There was an error!', error);
      });
  }

}
